// posthog-node skips errors carrying this flag but never sets it itself.
// Marking a reported error stops the same object from being captured twice,
// e.g. logged by a catch and then rethrown, or logged and shown in a toast.
// Mark only after capturing: posthog-node checks the flag on capture.
const PREVIOUSLY_CAPTURED_FLAG = '__posthog_previously_captured_error';

export function wasErrorReported(error: unknown): boolean {
  return (
    !!error &&
    typeof error === 'object' &&
    (error as Record<string, unknown>)[PREVIOUSLY_CAPTURED_FLAG] === true
  );
}

export function markErrorReported(error: unknown): void {
  if (!error || typeof error !== 'object') return;

  try {
    Object.defineProperty(error, PREVIOUSLY_CAPTURED_FLAG, {
      configurable: true,
      enumerable: false,
      value: true,
    });
  } catch {
    // Frozen objects cannot be marked; at worst they are reported twice.
  }
}
